// Dashboard components
import MDButton from "components/MDButton";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const PrintButton = ({ onClick, disabled, tooltip, ...props }) => {
  return (
    <Tooltip title={tooltip}>
      <MDButton
        onClick={onClick}
        disabled={disabled}
        variant="gradient"
        iconOnly
        size="small"
        type="button"
        {...props}
        // color={props?.style?.backgroundColor ? null : "success"}
        style={
          disabled ? { backgroundColor: "grey", color: "white" } : props?.style
        }
      >
        <Icon>print</Icon>
      </MDButton>
    </Tooltip>
  );
};

export default PrintButton;
